import { FC } from 'react';
import { RouteProps } from 'react-router-dom';
import * as pages from 'pages';
import { Business, Notification, Site, Sites, SupportSite, WorkerShiftConstant } from 'constant';

export const routes = {
  Login: {
    path: '/login',
  },
  HomePage: {
    path: '/homepage',
  },
  Home: {
    // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
    // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
    // path: `/:entity(${Sites.UNAPPROVED}|${Sites.APPROVED}|${Sites.MAP}|${WorkerShiftConstant.PLANNED_WORK_SITES}|${WorkerShiftConstant.WORKER_SHIFT_TABLES}|${WorkerShiftConstant.NEW_ENTRANTSENDOFF}|${WorkerShiftConstant.SendPhoto}|${WorkerShiftConstant.EducationStatus}|${SupportSite.AGENT}|${SupportSite.CHARGE}|${SupportSite.MAP})?`,
    path: `/:entity(${Sites.UNAPPROVED}|${Sites.APPROVED}|${Sites.MAP}|${WorkerShiftConstant.WORKER_SHIFT_TABLES}|${WorkerShiftConstant.NEW_ENTRANTSENDOFF}|${WorkerShiftConstant.SendPhoto}|${WorkerShiftConstant.EducationStatus}|${SupportSite.AGENT}|${SupportSite.CHARGE}|${SupportSite.MAP})?`,
    // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
    // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
  },
  ModalMock: {
    path: '/modal',
  },
  Terms: {
    path: '/terms',
  },
  SiteDetail: {
    path: `/site/:site_id/building/:buildingId/:entity(${Site.WORK_STATUS}|${Site.ALBUMS}|${Site.WORK_INFO})?`,
  },
  SiteDetailN: {
    path: `/site/:site_id/building/:buildingId/rkyDate/:rky_created_date/:entity(${Site.WORK_STATUS}|${Site.ALBUMS}|${Site.WORK_INFO})?`,
  },
  Notifications: {
    path: `/notifications/:entity(${Notification.RECEIVING}|${Notification.SENDING})?`,
  },
  BusinessDetail: {
    // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
    // 2025/02/27 FJ 3月分反映分 NO32 start
    // path: `/business-detail/:buildingId/:gyosya_code?/:gyosya_siten_code?/:entity(${Business.WORK_STATUS}|${Business.WORKER_INFO})?`,
    path: `/business-detail/:buildingId/:gyosya_code?/:gyosya_siten_code?/:first_gyosya_code?/:first_gyosya_siten_code?/:entity(${Business.WORK_STATUS}|${Business.WORKER_INFO})?`,
    // 2025/02/27 FJ 3月分反映分 NO32 end
    // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
  },
  SupportSiteList: {
    path: `/support-site-list/:entity(${SupportSite.AGENT}|${SupportSite.CHARGE}|${SupportSite.MAP})?`,
  },
  WorkShift: {
    // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
    // path: `/worker-shift/:entity(${WorkerShiftConstant.PLANNED_WORK_SITES}|${WorkerShiftConstant.WORKER_SHIFT_TABLES})?`,
    path: `/worker-shift/:entity(${WorkerShiftConstant.WORKER_SHIFT_TABLES})?`,
    // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
  },
  PrivacyPolicy: {
    path: '/privacyPolicy/:showFlag(WEB|APP)',
  },
  // 2026/03/09 施 CSV出力機能対応 start
  CsvOutput: {
    path: '/admin/csv-output/Lw202603test',
  },
  // 2026/03/09 施 CSV出力機能対応 end
};

export const publicRoutes: Array<RouteProps & { component: FC }> = [
  {
    path: routes.Login.path,
    component: pages.LoginPage,
    exact: true,
  },
  {
    path: routes.HomePage.path,
    component: pages.PageHome,
    exact: true,
  },
  {
    path: routes.ModalMock.path,
    component: pages.ModalMockPage,
    exact: true,
  },
  {
    path: routes.Terms.path,
    component: pages.Policy,
    exact: true,
  },
  {
    path: routes.PrivacyPolicy.path,
    component: pages.PrivacyPolicy,
    exact: true,
  },
];

export const privateRoutes: Array<RouteProps & { component: FC }> = [
  {
    path: routes.Home.path,
    component: pages.HomePage,
    exact: true,
  },
  { path: routes.SiteDetail.path, component: pages.SiteDetailPage, exact: true },
  { path: routes.SiteDetailN.path, component: pages.SiteDetailPage, exact: true },
  {
    path: routes.Notifications.path,
    component: pages.Notifications,
    exact: true,
  },
  {
    path: routes.BusinessDetail.path,
    component: pages.BusinessDetailPage,
    exact: true,
  },
  // 2026/03/09 施 CSV出力機能対応 start
  {
    path: routes.CsvOutput.path,
    component: pages.CsvOutputPage,
    exact: true,
  },
  // 2026/03/09 施 CSV出力機能対応 end
];
